const FAQ = ({ number, header, children }) => (
  <div className="d-md-flex mb-5 text-center text-md-start">
    <div className="flex-shrink-0 d-flex justify-content-center">
      <div className="number mb-3">{number}</div>
    </div>
    <div className="flex-grow-1 ms-md-4">
      <h3 className="text-uppercase mt-3 mb-3">{header}</h3>
      <p className="text-uppercase">{children}</p>
    </div>
  </div>
);

const FAQs = ({ angleBottomEdge }) => (
  <>
    <section className={`section-blue edge--top--reverse ${angleBottomEdge ? 'edge--bottom' : ''}`}>
      <div className="container">
        <h2 className="text-uppercase text-center">Frequently Asked Questions</h2>
        <div className="row">
          <div className="col-md-6">
            <FAQ number="1" header="Who can participate?">
              Race to Gem Mountain is open for everyone to participate.
            </FAQ>
          </div>
          <div className="col-md-6">
            <FAQ number="2" header="What should I post?">
              Social Posts and a YouTube video of you playing Race to Gem Mountain.
            </FAQ>
          </div>
          <div className="col-md-6">
            <FAQ
              number="3"
              header="What should I do if I get a challenge I don't have the necessary items for?"
            >
              Spin again for a new challenge.
            </FAQ>
          </div>
          <div className="col-md-6">
            <FAQ number="4" header="What if I fail my challenge?">
              You can try again as many times as it takes to win.
            </FAQ>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default FAQs;
